import { render, staticRenderFns } from "./NoRecordFound.vue?vue&type=template&id=404c7aa9&scoped=true"
import script from "./NoRecordFound.vue?vue&type=script&lang=ts"
export * from "./NoRecordFound.vue?vue&type=script&lang=ts"
import style0 from "./NoRecordFound.vue?vue&type=style&index=0&id=404c7aa9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c7aa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404c7aa9')) {
      api.createRecord('404c7aa9', component.options)
    } else {
      api.reload('404c7aa9', component.options)
    }
    module.hot.accept("./NoRecordFound.vue?vue&type=template&id=404c7aa9&scoped=true", function () {
      api.rerender('404c7aa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/NoRecordFound.vue"
export default component.exports